import { z } from 'zod'
import { CourtesyStatus } from '~library/enums'
import {
  assignBenefitsRecordSchema,
  businessCardCommonSchema,
  managerBenefitCommonSchema
} from '~library/models'
import { courtesyArrangementRecordSchema } from './courtesy-arrangement-record'

/** data上面部分的suitData */
export const suitCourtesyDataSchema = z.object({
  /**
   * 分類
   * PDBG:超額行李
   * LOUG:貴賓室
   * PRCK:優先劃位櫃檯
   * PRBD:優先登機
   * PRBG:優先裝卸行李
   * */
  type: z.string(),
  /** 券號 */
  couponNo: z.string()
})

/** 禮遇詳細資訊 */
export const assignBenefitsSchema = z
  .object({
    /** 券號 */
    couponNo: z.string(),
    /** 狀態 */
    status: z.nativeEnum(CourtesyStatus),
    /** 套裝子項目清單 for 未指派 */
    suitCourtesy: z.array(suitCourtesyDataSchema),
    /** 使用起始時間 */
    useStartTime: z.string(),
    /** 使用截止時間 */
    useEndTime: z.string(),
    /** 來源 */
    source: z.string(),
    /** 建檔日期 */
    createTime: z.string(),
    /** 建檔人員 */
    createBy: z.string(),
    /** 指派禮遇紀錄 */
    assignBenefitsRecord: assignBenefitsRecordSchema.nullable(),
    /** 禮遇安排紀錄 */
    courtesyArrangementRecord: courtesyArrangementRecordSchema.nullable(),
    /** 商務卡資訊 */
    businessCardInformation: businessCardCommonSchema.nullable()
  })
  .merge(managerBenefitCommonSchema)

/** 指派禮遇紀錄 */
export interface AssignBenefitsRecord
  extends z.infer<typeof assignBenefitsRecordSchema> {}

/** 禮遇詳細資訊 */
export interface AssignBenefits extends z.infer<typeof assignBenefitsSchema> {}

/** 禮遇安排紀錄 Schema */
export interface AssignBenefitsCourtesyArrangementRecordData
  extends z.infer<typeof courtesyArrangementRecordSchema> {}
